import {Icon} from "ant-design-vue";

export const admin_icon = Icon.createFromIconfontCN({
    // scriptUrl:'//at.alicdn.com/t/font_3133804_6j711fi9o5u.js',
    scriptUrl:'//at.alicdn.com/t/c/font_4173551_95qldqw6nmm.js',
})
